import { render, staticRenderFns } from "./ParallelogramButton.vue?vue&type=template&id=bb42f674&scoped=true&"
import script from "./ParallelogramButton.vue?vue&type=script&lang=js&"
export * from "./ParallelogramButton.vue?vue&type=script&lang=js&"
import style0 from "./ParallelogramButton.vue?vue&type=style&index=0&id=bb42f674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb42f674",
  null
  
)

export default component.exports